import React from 'react';
import { Box } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

// Reusable checkbox icons for all invoice-related tables
export const CHECKED_ICON = (
  <Box
    sx={{
      width: 20,
      height: 20,
      borderRadius: 2,
      bgcolor: '#E6F6ED',
      border: '1px solid #4CAF50',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background-color 120ms ease, border-color 120ms ease',
    }}
  >
    <CheckRoundedIcon sx={{ fontSize: 16, color: '#2E7D32' }} />
  </Box>
);

export const UNCHECKED_ICON = (
  <Box
    sx={{
      width: 20,
      height: 20,
      borderRadius: 2,
      border: '1px solid #D0D5DD',
      bgcolor: '#fff',
      transition: 'background-color 120ms ease, border-color 120ms ease',
    }}
  />
);